import { KnowledgeBaseAdherenceCorrectness } from "@repo/app-types/entities/knowledgeBaseAdherence";
import {
  IconCircleCheck,
  IconCircleX,
  IconHelpCircle,
} from "@tabler/icons-react";
import type { FC } from "react";
import { tv } from "tailwind-variants";

export interface KnowledgeBaseAdherenceCorrectnessIconProps {
  correctness: KnowledgeBaseAdherenceCorrectness;
}

const iconComponent: Record<
  KnowledgeBaseAdherenceCorrectness,
  typeof IconCircleCheck
> = {
  [KnowledgeBaseAdherenceCorrectness.Correct]: IconCircleCheck,
  [KnowledgeBaseAdherenceCorrectness.Incorrect]: IconCircleX,
  [KnowledgeBaseAdherenceCorrectness.Unknown]: IconHelpCircle,
};

const iconStyle = tv({
  base: "size-4 shrink-0",
  variants: {
    correctness: {
      [KnowledgeBaseAdherenceCorrectness.Correct]: "text-success",
      [KnowledgeBaseAdherenceCorrectness.Incorrect]: "text-destructive",
      [KnowledgeBaseAdherenceCorrectness.Unknown]: "text-gray-600",
    },
  },
});

export const KnowledgeBaseAdherenceCorrectnessIcon: FC<
  KnowledgeBaseAdherenceCorrectnessIconProps
> = (props) => {
  const Icon = iconComponent[props.correctness];

  return <Icon className={iconStyle({ correctness: props.correctness })} />;
};
